// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2Df6O","selected":"Chip_selected__CGpfs"};